export const DiagramTools = Object.freeze({
	change: 'change',
	highlight: 'highlight',
	point: 'point',
	select: 'select'
});